<section class="position-relative">
  <button class="btn-close-modal" *ngIf="!modalData.textButtons" (click)="activeModal.close()">
    <i class="bi bi-x-lg"></i>
  </button>

  <div
    *ngIf="modalData && modalData.title"
    class="modal-header position-relative modal-confirmation justify-content-center"
    [ngClass]="{
      'no-padding': modalData.no_padding_header,
    }"
  >
    <h4 class="modal-title text-blue-100 text-center text-size-md" [innerHTML]="modalData.title"></h4>
  </div>

  <div
    class="modal-body text-center"
    *ngIf="modalData && modalData.message"
    [ngClass]="{
      'no-padding': modalData.no_padding_header,
    }"
  >
    <p class="" [innerHTML]="modalData.message"></p>
  </div>

  <div class="modal-footer" [class.justify-content-center]="modalData.textButtons.cancel" *ngIf="modalData.textButtons">
    <button
      type="button"
      class="btn btn-primary-blue rounded-pill"
      (click)="confirm()"
      *ngIf="modalData.textButtons.confirm"
      [id]="modalData.textButtons && modalData.textButtons.confirm.id ? modalData.textButtons.confirm.id : null"
    >
      {{ modalData.textButtons ? modalData.textButtons.confirm.text : 'Confirmar' }}
    </button>

    <button
      type="button"
      class="btn btn-secondary rounded-pill"
      (click)="cancel()"
      *ngIf="modalData.textButtons.cancel"
      [id]="modalData.textButtons && modalData.textButtons.cancel.id ? modalData.textButtons.cancel.id : null"
    >
      <i class="bi bi-arrow-left"></i>
      {{ modalData.textButtons ? modalData.textButtons.cancel.text : 'Cancelar' }}
    </button>
  </div>
</section>
